module.exports = __webpack_public_path__ + "img/empty-approval-history.612c539e.svg";